import { $t } from 'hooks/i18n';
import { BreadCrumb } from 'primereact/breadcrumb';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { CanView } from 'components/Can';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { ExportPageData } from 'components/ExportPageData';
import { FilterTags } from 'components/FilterTags';
import { ImageViewer } from 'components/ImageViewer';
import { InputText } from 'primereact/inputtext';
import { Link } from 'react-router-dom';
import { PageRequestError } from 'components/PageRequestError';
import { ProgressSpinner } from 'primereact/progressspinner';
import { SplitButton } from 'primereact/splitbutton';
import { Title } from 'components/Title';
import BranchmasterViewPage from 'pages/branchmaster/View';
import DistrictViewPage from 'pages/district/View';
import PolicestationViewPage from 'pages/policestation/View';
import StatesViewPage from 'pages/states/View';
import useApp from 'hooks/useApp';
import useAuth from 'hooks/useAuth';
import useUtils from 'hooks/useUtils';

import useListPage from 'hooks/useListPage';
import MasterDetailPages from './MasterDetailPages';
const MembermasterBranchPage = (props) => {
		const auth = useAuth();
	const app = useApp();
	const utils = useUtils();
	const filterSchema = {
		search: {
			tagTitle: $t('search'),
			value: '',
			valueType: 'single',
			options: [],
		},
		joiningdate: {
			tagTitle: $t('joiningdate'),
			value: [],
			valueType: 'range-date',
			options: [],
		}
	}
	const pageController = useListPage(props, filterSchema);
	const filterController = pageController.filterController;
	const { records, pageReady, loading, selectedItems, apiUrl, currentRecord, sortBy, sortOrder, apiRequestError, setSelectedItems, getPageBreadCrumbs, onSort, deleteItem, setCurrentRecord, pagination } = pageController;
	const { filters, setFilterValue } = filterController;
	const { totalPages, currentPage, limit, setPrevPage, setNextPage } =  pagination;
	function ActionButton(data){
		const items = [
		{
			label: $t('view'),
			command: (event) => { app.navigate(`/membermaster/view/${data.memberid}`) },
			icon: "pi pi-eye",
			visible: () => auth.canView('membermaster/view')
		},
		{
			label: $t('edit'),
			command: (event) => { app.navigate(`/membermaster/edit/${data.memberid}`) },
			icon: "pi pi-pencil",
			visible: () => auth.canView('membermaster/edit')
		},
		{
			label: $t('delete'),
			command: (event) => { deleteItem(data.memberid) },
			icon: "pi pi-trash",
			visible: () => auth.canView('membermaster/delete')
		}
	]
	.filter((item) => {
		if(item.visible){
			return item.visible()
		}
		return true;
	});
		return (<SplitButton dropdownIcon="pi pi-bars" className="dropdown-only p-button-text p-button-plain" model={items} />);
	}
	function MemberidTemplate(data){
		if(data){
			return (
				<Link to={`/membermaster/view/${data.memberid}`}> { data.memberid }</Link>
			);
		}
	}
	function JoiningdateTemplate(data){
		if(data){
			return (
				<>{utils.humanDate( data.joiningdate )}</>
			);
		}
	}
	function DobTemplate(data){
		if(data){
			return (
				<>{utils.humanDate( data.dob )}</>
			);
		}
	}
	function PolicestationTemplate(data){
		if(data){
			return (
				<>{data.policestation && <Button className="p-button-text" icon="pi pi-eye" label={$t('policestation')} onClick={() => app.openPageDialog(<PolicestationViewPage isSubPage apiPath={`/policestation/view/${data.policestation}`} />, {closeBtn: true })} /> }</>
			);
		}
	}
	function DistrictTemplate(data){
		if(data){
			return (
				<>{data.district && <Button className="p-button-text" icon="pi pi-eye" label={$t('district')} onClick={() => app.openPageDialog(<DistrictViewPage isSubPage apiPath={`/district/view/${data.district}`} />, {closeBtn: true })} /> }</>
			);
		}
	}
	function StatenameTemplate(data){
		if(data){
			return (
				<>{data.statename && <Button className="p-button-text" icon="pi pi-eye" label={$t('states')} onClick={() => app.openPageDialog(<StatesViewPage isSubPage apiPath={`/states/view/${data.statename}`} />, {closeBtn: true })} /> }</>
			);
		}
	}
	function BranchcodeTemplate(data){
		if(data){
			return (
				<>{data.branchcode && <Button className="p-button-text" icon="pi pi-eye" label={$t('branchmaster')} onClick={() => app.openPageDialog(<BranchmasterViewPage isSubPage apiPath={`/branchmaster/view/${data.branchcode}`} />, {closeBtn: true })} /> }</>
			);
		}
	}
	function EmailTemplate(data){
		if(data){
			return (
					<a className="p-button-text" href={`mailto:${data.email}`}>{ data.email }</a>
			);
		}
	}
	function PhotoUploadTemplate(data){
		if(data){
			return (
				<><ImageViewer imageSize="small" previewSize="" src={data.photo_upload} width="50px" height="50px" numDisplay={1} style={{maxWidth:'100%'}} /></>
			);
		}
	}
	function IdUploadFrontTemplate(data){
		if(data){
			return (
				<><ImageViewer imageSize="small" previewSize="" src={data.id_upload_front} width="50px" height="50px" numDisplay={1} style={{maxWidth:'100%'}} /></>
			);
		}
	}
	function IdUploadBackTemplate(data){
		if(data){
			return (
				<><ImageViewer imageSize="small" previewSize="" src={data.id_upload_back} width="50px" height="50px" numDisplay={1} style={{maxWidth:'100%'}} /></>
			);
		}
	}
	function Id2UploadFrontTemplate(data){
		if(data){
			return (
				<><ImageViewer imageSize="small" previewSize="" src={data.id2_upload_front} width="50px" height="50px" numDisplay={1} style={{maxWidth:'100%'}} /></>
			);
		}
	}
	function Id2UploadBackTemplate(data){
		if(data){
			return (
				<><ImageViewer imageSize="small" previewSize="" src={data.id2_upload_back} width="50px" height="50px" numDisplay={1} style={{maxWidth:'100%'}} /></>
			);
		}
	}
	function PanUploadTemplate(data){
		if(data){
			return (
				<><ImageViewer imageSize="small" previewSize="" src={data.pan_upload} width="50px" height="50px" numDisplay={1} style={{maxWidth:'100%'}} /></>
			);
		}
	}
	function UseridTemplate(data){
		if(data){
			return (
				<>{ data.users_userid }</>
			);
		}
	}
	function MasterDetailBtnTemplate(data){
		if(data){
			return (
				<><Button className="p-button-text" onClick={()=>setCurrentRecord(data)} icon="pi pi-caret-down" label="" /></>
			);
		}
	}
	function PageLoading(){
		if(loading){
			return (
				<>
					<div  className="flex align-items-center justify-content-center text-gray-500 p-3">
						<div><ProgressSpinner style={{width:'30px', height:'30px'}} /> </div>
						<div  className="font-bold text-lg">{$t('loading')}</div>
					</div>
				</>
			);
		}
	}
	function EmptyRecordMessage(){
		if(pageReady && !records.length){
			return (
				<div className="text-lg mt-3 p-3 text-center text-400 font-bold">
					{$t('noRecordFound')}
				</div>
			);
		}
	}
	function MultiDelete() {
		if (selectedItems.length) {
			return (
				<div className="m-2 flex-grow-0">
					<Button onClick={() => deleteItem(selectedItems)} icon="pi pi-trash" className="p-button-danger" title={$t('deleteSelected')}/>
				</div>
			)
		}
	}
	function ExportData() {
		if (props.exportData && records.length) {
			const downloadFileName = `${utils.dateNow()}-membermaster`;
			return (
				<div className="m-2">
					<ExportPageData  pageUrl={apiUrl} downloadFileName={downloadFileName} butonLabel={$t('')} tooltip={$t('export')} buttonIcon="pi pi-print" />
				</div>
			);
		}
	}
	function PagerControl() {
		if (props.paginate && totalPages > 1) {
	return (
		<div className="flex-grow-1">
			<div className="flex  justify-content-center">
				<div  className="m-2">
					<Button disabled={pagination.currentPage <= 1} label="Previous" onClick={()=>pagination.setPrevPage()} icon="pi pi-arrow-left" />
				</div>
				<div className="m-2">
					<Button disabled={pagination.currentPage >= totalPages} label="Next" onClick={()=>pagination.setNextPage()} icon="pi pi-arrow-right" icon-pos="right" />
				</div>
			</div>
		</div>
	)
		}
	}
	function PageActionButtons() {
		return (
			<div className="flex flex-wrap">
	<CanView pagePath="membermaster/delete">
		<MultiDelete />
	</CanView>
				<ExportData />
			</div>
		);
	}
	function PageFooter() {
		if (pageReady && props.showFooter) {
			return (
				<div className="flex flex-wrap">
					<PageActionButtons />
					<PagerControl />
				</div>
			);
		}
	}
	function PageBreadcrumbs(){
		if(props.showBreadcrumbs) {
			const items = getPageBreadCrumbs();
			return (items.length > 0 && <BreadCrumb className="mb-3" model={items} />);
		}
	}
	if(apiRequestError){
		return (
			<PageRequestError error={apiRequestError} />
		);
	}
	return (
<main id="MembermasterBranchPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container-fluid">
            <div className="grid justify-content-between align-items-center">
                <div className="col " >
                    <Title title={$t('members')}   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
                <div className="col-fixed " >
                    <Link to={`/membermaster/add`}>
                        <Button label={$t('addNewMember')} icon="pi pi-plus" type="button" className="p-button w-full bg-primary "  />
                        </Link>
                    </div>
                    <div className="col-12 md:col-3 " >
                        <span className="p-input-icon-left w-full">
                        <i className="pi pi-search" />
                        <InputText placeholder={$t('search')} className="w-full" value={filters.search.value}  onChange={(e) => setFilterValue('search', e.target.value)} />
                        </span>
                    </div>
                    <div className="col-12 md:col-3 comp-grid" >
                        <div className="card  sp-3 mb-3">
                            <div className="">
                                <Calendar showIcon={true} showButtonBar={true} dateFormat="yy-mm-dd" hourFormat="24" className="w-full" selectionMode="range" value={filters.joiningdate.value} onChange={(e) => setFilterValue('joiningdate', e.value)} placeholder={$t('selectJoiningDate')}   />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        }
        <section className="page-section " >
            <div className="container-fluid">
                <div className="grid ">
                    <div className="col comp-grid" >
                        <FilterTags filterController={filterController} />
                        <div >
                            <PageBreadcrumbs />
                            <div className="grid ">
                                <div className="col">
                                    <div className="page-records">
                                        <DataTable 
                                            lazy={true} 
                                            loading={loading} 
                                            selectionMode="checkbox" selection={selectedItems} onSelectionChange={e => setSelectedItems(e.value)}
                                            value={records} 
                                            dataKey="memberid" 
                                            sortField={sortBy} 
                                            sortOrder={sortOrder} 
                                            onSort={onSort}
                                            className=" p-datatable-sm" 
                                            stripedRows={true}
                                            showGridlines={false} 
                                            rowHover={true} 
                                            responsiveLayout="stack" 
                                            emptyMessage={<EmptyRecordMessage />} 
                                            >
                                            {/*PageComponentStart*/}
                                            <Column selectionMode="multiple" headerStyle={{width: '2rem'}}></Column>
                                            <Column headerStyle={{width: '3rem'}} field=""  body={MasterDetailBtnTemplate}  ></Column>
                                            <Column  field="memberid" header={$t('memberid')} body={MemberidTemplate} sortable={true} ></Column>
                                            <Column  field="membername" header={$t('membername')}  sortable={true} ></Column>
                                            <Column  field="groupid" header={$t('groupid')}  sortable={true} ></Column>
                                            <Column  field="father_name" header={$t('fatherName')}  sortable={true} ></Column>
                                            <Column  field="husband_name" header={$t('husbandName')}  sortable={true} ></Column>
                                            <Column  field="joiningdate" header={$t('joiningdate')} body={JoiningdateTemplate} sortable={true} ></Column>
                                            <Column  field="dob" header={$t('dob')} body={DobTemplate} sortable={true} ></Column>
                                            <Column  field="age" header={$t('age')}  sortable={true} ></Column>
                                            <Column  field="addressline1" header={$t('addressline1')}  sortable={true} ></Column>
                                            <Column  field="addressline2" header={$t('addressline2')}  sortable={true} ></Column>
                                            <Column  field="policestation" header={$t('policestation')} body={PolicestationTemplate} sortable={true} ></Column>
                                            <Column  field="district" header={$t('district')} body={DistrictTemplate} sortable={true} ></Column>
                                            <Column  field="pincode" header={$t('pincode')}  sortable={true} ></Column>
                                            <Column  field="statename" header={$t('statename')} body={StatenameTemplate} sortable={true} ></Column>
                                            <Column  field="branchcode" header={$t('branchcode')} body={BranchcodeTemplate} sortable={true} ></Column>
                                            <Column  field="id1" header={$t('id1')}  sortable={true} ></Column>
                                            <Column  field="id2" header={$t('id2')}  sortable={true} ></Column>
                                            <Column  field="idcardnumber" header={$t('idcardnumber')}  sortable={true} ></Column>
                                            <Column  field="idcardnumber_ex" header={$t('idcardnumberEx')}  sortable={true} ></Column>
                                            <Column  field="religion" header={$t('religion')}  sortable={true} ></Column>
                                            <Column  field="caste" header={$t('caste')}  sortable={true} ></Column>
                                            <Column  field="occupation" header={$t('occupation')}  sortable={true} ></Column>
                                            <Column  field="qualification" header={$t('qualification')}  sortable={true} ></Column>
                                            <Column  field="mobileno" header={$t('mobileno')}  sortable={true} ></Column>
                                            <Column  field="mobileno_ex" header={$t('mobilenoEx')}  sortable={true} ></Column>
                                            <Column  field="nomineename" header={$t('nomineename')}  sortable={true} ></Column>
                                            <Column  field="mother_name" header={$t('motherName')}  sortable={true} ></Column>
                                            <Column  field="marital_status" header={$t('maritalStatus')}  sortable={true} ></Column>
                                            <Column  field="bankname" header={$t('bankname')}  sortable={true} ></Column>
                                            <Column  field="accountno" header={$t('accountno')}  sortable={true} ></Column>
                                            <Column  field="ifsec" header={$t('ifsec')}  sortable={true} ></Column>
                                            <Column  field="map_upload" header={$t('mapUpload')}  sortable={true} ></Column>
                                            <Column  field="nominee_relation" header={$t('nomineeRelation')}  sortable={true} ></Column>
                                            <Column  field="nominee_age" header={$t('nomineeAge')}  sortable={true} ></Column>
                                            <Column  field="pancard" header={$t('pancard')}  sortable={true} ></Column>
                                            <Column  field="gender" header={$t('gender')}  sortable={true} ></Column>
                                            <Column  field="pan_verify" header={$t('panVerify')}  sortable={true} ></Column>
                                            <Column  field="aadhar_verify" header={$t('aadharVerify')}  sortable={true} ></Column>
                                            <Column  field="email" header={$t('email')} body={EmailTemplate} sortable={true} ></Column>
                                            <Column  field="account_verify" header={$t('accountVerify')}  sortable={true} ></Column>
                                            <Column  field="nickname" header={$t('nickname')}  sortable={true} ></Column>
                                            <Column  field="house_member_adult_male" header={$t('houseMemberAdultMale')}  sortable={true} ></Column>
                                            <Column  field="resk_evaluated" header={$t('reskEvaluated')}  sortable={true} ></Column>
                                            <Column  field="house_member_adult_female" header={$t('houseMemberAdultFemale')}  sortable={true} ></Column>
                                            <Column  field="house_member_child" header={$t('houseMemberChild')}  sortable={true} ></Column>
                                            <Column  field="income" header={$t('income')}  sortable={true} ></Column>
                                            <Column  field="expenditure" header={$t('expenditure')}  sortable={true} ></Column>
                                            <Column  field="loan_purpose" header={$t('loanPurpose')}  sortable={true} ></Column>
                                            <Column  field="photo_upload" header={$t('photoUpload')} body={PhotoUploadTemplate} sortable={true} ></Column>
                                            <Column  field="id_upload_front" header={$t('aadharUploadFront')} body={IdUploadFrontTemplate} sortable={true} ></Column>
                                            <Column  field="id_upload_back" header={$t('aadharUploadBack')} body={IdUploadBackTemplate} sortable={true} ></Column>
                                            <Column  field="id2_upload_front" header={$t('voterUploadFront')} body={Id2UploadFrontTemplate} sortable={true} ></Column>
                                            <Column  field="id2_upload_back" header={$t('voterUploadBack')} body={Id2UploadBackTemplate} sortable={true} ></Column>
                                            <Column  field="pan_upload" header={$t('panUpload')} body={PanUploadTemplate} sortable={true} ></Column>
                                            <Column  field="house_upload" header={$t('houseUpload')}  sortable={true} ></Column>
                                            <Column  field="sign_upload" header={$t('signUpload')}  sortable={true} ></Column>
                                            <Column  field="users_userid" header={$t('usersUserid')} body={UseridTemplate}  ></Column>
                                            <Column  field="nomineedob" header={$t('nomineedob')}   ></Column>
                                            <Column headerStyle={{width: '2rem'}} headerClass="text-center" body={ActionButton}></Column>
                                            {/*PageComponentEnd*/}
                                        </DataTable>
                                    </div>
                                    <PageFooter />
                                </div>
                                {
                                (currentRecord && !props.isSubPage) && 
                                <div className="col-12">
                                    <div className="card p-0">
                                        <MasterDetailPages masterRecord={currentRecord} scrollIntoView={true} />
                                    </div>
                                </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
	);
}
MembermasterBranchPage.defaultProps = {
	primaryKey: 'memberid',
	pageName: 'membermaster',
	apiPath: 'membermaster/branch',
	routeName: 'membermasterbranch',
	msgBeforeDelete: $t('promptDeleteRecord'),
	msgTitle: $t('deleteRecord'),
	msgAfterDelete: $t('recordDeletedSuccessfully'),
	showHeader: true,
	showFooter: true,
	paginate: true,
	isSubPage: false,
	showBreadcrumbs: true,
	exportData: true,
	importData: false,
	keepRecords: false,
	multiCheckbox: true,
	search: '',
	fieldName: null,
	fieldValue: null,
	sortField: '',
	sortDir: '',
	pageNo: 1,
	limit: 50,
}
export default MembermasterBranchPage;
